import { Container, Typography } from '@mui/material';
import Typewriter from 'typewriter-effect';

export default function Header() {
  const animatedTexts = {
    first: 'ሁሉንም አይነት',
    second: 'ከየትኛውም ቦታ',
    third: 'በማንኛውም ጊዜና ሁኔታ',
  };
  return (
    <Container maxWidth="xl" sx={{ pb: 5 }}>
      <Typography variant="h4" sx={{ color: 'gray' }}>
        ያግኙን
      </Typography>
      <Typography variant="h6" sx={{ display: 'flex', color: 'text.secondary' }}>
        <Typewriter
          options={{
            strings: [animatedTexts.first, animatedTexts.second, animatedTexts.third],
            autoStart: true,
            loop: true,
            deleteSpeed: 10,
          }}
        />{' '}
        ሃሳብ እንቀበላለን።
      </Typography>
    </Container>
  );
}
